var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("a-button-primary " + _vm.buttonClass),attrs:{"type":_vm.buttonPrimary.type}},[_c('i',{class:[_vm.buttonPrimary.sending
    ? 'far fa-spinner fa-spin' : _vm.buttonIcon
    , 'margin-right-xsmall']}),_c('span',[_vm._v(_vm._s(_vm.buttonPrimary.action))])])}
var staticRenderFns = []

export { render, staticRenderFns }